import React from 'react';
import {FieldViewReferenceProps} from "../../../../render/view-reference";
import ProjectIconUI5 from "../../../../../gd-components/icons/project/project-icon-ui5";
import {ItemIconSize} from "../../../../../gd-components/icons/@const";

export default function FieldProject_ViewReference(props:FieldViewReferenceProps) {

    const value = props.field.getViewValue(props.model)

    if (!value) {
        return (
            <div className="ui5-txt-less-important txt-truncate">
                No parent
            </div>
        );
    }

    const onClick = ()=>{
        gd.navigation.goToProject(value)
    }

    const project = gd.session.projects.get(value)!

    return (
        <div className={Classes("ui5-control-button-36",props.className)} onClick={onClick}>
            <ProjectIconUI5 project={project} size={ItemIconSize.SIZE_14} colorize={true} className="m-r-8"/>
            <span className="ui5-txt-default">{project?.name}</span>
        </div>
    )


}


